var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"oci-projects-button-container"},[_c('b-button',{attrs:{"type":"submit"},on:{"click":_vm.cancelSigIn}},[_vm._v(" Cancel sign-in ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }